<template>
  <div v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" class="image-collections">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-photo">
      <div class="hello" >
       <div class="upload">
         <div class="upload-btn">
           <div class="upload_warp_left" @click="fileClick" >
               <button class="btn btn-success f-size">本地上传</button>
           </div>
               <button-add @click="toAddPage" value="人脸库" style="margin-left:20px" />
               <button-cancel value="清除" @cancel="batchDownloadNotice" style="margin-left: 10px;" class="f-size"/>
           <!-- <div class="upload_warp_text">
               选中{{imgList.length}}张文件，共{{bytesToSize(this.size)}}; 最多上传<span class="text-primary"> 6</span> 张图片！
           </div> -->
          </div>
           <div class="upload_warp">
               <div class="upload_warp_img" v-show="imgList.length!=0" >
                   <div class="upload_warp_img_div" v-for="(item,index) of imgList" >
                       <div class="upload_warp_img_div_top" >
                           <div class="upload_warp_img_div_text" >
                               <!-- {{item.file.name}} -->
                           </div>
                           <span class="upload_warp_img_div_del" @click="fileDel(index)">X</span>
                           <!-- <img src="/src/assets/address.png" class="upload_warp_img_div_del" @click="fileDel(index)"> -->
                       </div>
                       <!-- <img :src="item.file.src"> -->
                       <img :src="item">
                   </div>
               </div>
           </div>
           <input @change="fileChange($event)" type="file" id="upload_file" multiple style="display: none"/>
    </div>
   </div>
    </div>
    <div class="search-line">
      <div class="btn-box">
      <span style="display: inline-block;color: #48576a;font-size: 14px;line-height: 30px;margin-right: 5px;">时间</span>
        <el-date-picker v-model="timevalue"  size="small" type="daterange" style="width: 280px;" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
                        align="right" value-format="yyyy-MM-dd">
        </el-date-picker>
        <input-select selectTitle="监测点" :selectValue="requestData.deviceCode" :selectKey="'deviceCode'" :selectData="fixTypeList" @search="search" style="margin-left:20px"/>
        <input-select selectTitle="摄像机通道" :selectValue="requestData.channelId" :selectKey="'channelId'" :selectData="channelList" @search="search" style="margin-left:20px"/>
        <div style="display: flex;justify-content: flex-start;align-items: center;margin-left: 20px;">
          <span style="color: #666666;margin-right: 5px">相似度</span>
          <el-input placeholder="60" v-model="similarity" size="small" style="width: 120px;" class="payDeadInput" type="number" >
            <template slot="append">%</template>
          </el-input>
        </div>
        <button class="btn f-size" style="margin-left:20px;cursor:pointer;font-size:16px" @click="uploadPicture">搜索</button>
      </div>
    </div>

    <div class="background">
      <div class="box" v-for="item in tableData">
        <div class="information">
          <div class="photo">
            <img :src="item.picUrl" alt="" class="photo2">
          </div>
          <!-- <div class="person">
            <div>
              <span>相似度：</span>
              <span>{{item.similary}}</span>
            </div>
          </div> -->
          <div>
          <el-progress type="circle" :percentage="item.similary" color="#3462f6" stroke-width="10"></el-progress>
          <div>相似度</div>
          </div>
        </div>
        <div class="position">
          <div>{{item.deviceName}}</div>
          <div>{{item.time}}</div>
        </div>
      </div>
    </div>

<!--    <el-pagination-->
<!--      background-->
<!--      @size-change="handleSizeChange"-->
<!--      @current-change="handleCurrentChange"-->
<!--      style="margin-top:15px"-->
<!--      :page-sizes="[12, 20, 50, 100]"-->
<!--      :current-page="requestData.pageNum"-->
<!--      :page-size="requestData.pageSize"-->
<!--      layout="total, sizes, prev, pager, next, jumper"-->
<!--      :total="total">-->
<!--    </el-pagination>-->

      <el-dialog title="人脸库" :visible.sync="showTip" width="1300px">
        <div style="display: flex;justify-content: flex-start;align-items: center;margin-left: 20px;">
          <span style="color: #666666;margin-right: 5px">姓名</span>
          <el-input placeholder="请输入姓名" v-model="searchKey" size="small" style="width: 120px;" class="payDeadInput">
          </el-input>
          <button class="btn f-size" style="margin-left:20px" @click="getPersonPage">搜索</button>
        </div>
        <div class="background">
          <div class="box" v-for="(item,index) in tableData2" @click="personChoose(item,index)" :class="{'active':indexList.indexOf(item.picUrl)>-1}">
            <div class="information">
              <div class="photo">
                <img :src="item.picUrl" alt="" class="photo2">
              </div>
              <div class="person">
                <div>
                  <span>姓名：</span>
                  <span>{{item.personName||'无'}}</span>
                </div>
                <div class="gender">
                  <span>手机号：</span>
                  <span>{{item.phone||'无'}}</span>
                </div>
                <div class="address">
                  <span>住户：</span>
                  <span>{{item.enterpriseName||'无'}}</span>
                </div>
              </div>
            </div>
            <div class="position">
              <div>{{item.deviceName}}</div>
              <div>{{item.time}}</div>
            </div>
          </div>
        </div>

        <el-pagination
          background
          @size-change="handleSizeChange2"
          @current-change="handleCurrentChange2"
          style="margin-top:15px"
          :page-sizes="[6, 18, 50, 100]"
          :current-page="pageNum2"
          :page-size="pageSize2"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total2">
        </el-pagination>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showTip = false" size="small">取 消</el-button>
        <el-button type="primary" @click="confirm()" size="small">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/FaceRecognition";
import { bus } from "../../../utils/bus";
import { errorHandler } from "../../../utils/errorHandler";
import ButtonAdd from "../../../components/common/buttons/button-add";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { nAlert, nError, nSuccess } from "../../../utils/notice";

export default {
  components: {
    ButtonAdd,
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    Breadcrumb,
    ButtonCancel
  },
  name: "image-collections",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "人脸应用",
          name: "monitoring-point-management"
        },
        {
          value: "以图搜图"
        }
      ],
      fixTypeList: [],
      requestData: {
        searchKey: "",
        pageSize: 12,
        pageNum: 1,
        startTime: "",
        endTime: "",
        deviceCode: ""
      },
      uploadUrl: "",
      total: 0,
      timevalue: [],
      tableData: [],

      imgList: [],
      size: 0,
      pictureList: [],
      faceDatabaseList: [],

      similarity: "",
      showTip: false,
      pageNum2: 1,
      pageSize2: 6,

      total2: 0,
      tableData2: [],
      indexList: [],

      searchKey: "",
      deviceCode: "",

      channelList:[
        {label:"1",key:"1"},
        {label:"2",key:"2"}
      ],

      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }]
      },

      loading:false

    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getPage();
    this.getCreateTime();
    this.getFacePointList();
    this.getPersonPage();
  },
  activated() {
    this.getPage();
  },

  methods: {
    getCreateTime() {
      this.timevalue = [];
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1;
      let date =
        nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      let hour =
        nowDate.getHours() < 10 ? "0" + nowDate.getHours() : nowDate.getHours();
      let minute =
        nowDate.getMinutes() < 10
          ? "0" + nowDate.getMinutes()
          : nowDate.getMinutes();
      let second =
        nowDate.getSeconds() < 10
          ? "0" + nowDate.getSeconds()
          : nowDate.getSeconds();
      this.timevalue[0] = year + "-" + month + "-" + date ;
      this.timevalue[1] = year + "-" + month + "-" + date;
    },
    getPage() {
      if (this.timevalue) {
        this.requestData.startTime = this.timevalue[0];
        this.requestData.endTime = this.timevalue[1];
      } else {
        this.requestData.startTime = "";
        this.requestData.endTime = "";
      }
      this.$axios
        .post(api.getFaceRecordPage, this.requestData)
        .then(res => {
          // console.log(res);
          return;
          this.total = res.data.data.total;
          let list = res.data.data.list;
          list.map(v => {
            if (v.gender == "1") {
              v.genderText = "男";
            } else {
              v.genderText = "女";
            }
            if (v.isFacemask) {
              v.isFacemaskText = "有";
            } else {
              v.isFacemaskText = "无";
            }
          });
          this.tableData = list;
        })
        .catch(errorHandler("获取人脸库失败"));
    },
    getFacePointList() {
      this.$axios
        .post(api.getFacePointList, {})
        .then(res => {
          let data = res.data.data;
          data.map(v => {
            v.key = v.deviceCode;
            v.label = v.name;
          });
          // data.unshift({ key: "", label: "全部" });
          this.fixTypeList = data || [];
          // if (this.fixTypeList.length > 0) {
          //   this.requestData.deviceCode = this.fixTypeList[0].deviceCode;
          // }
          // this.requestData.deviceCode=this.fixTypeList[0].key
          // this.deviceCode= this.fixTypeList[0].key

        })
        .catch(errorHandler("获取摄像机列表失败"));
    },
    getPersonPage() {
      let reqData = {};
      reqData.pageNum = this.pageNum2;
      reqData.pageSize = this.pageSize2;
      reqData.searchKey = this.searchKey;
      this.$axios
        .post(api.getFaceAuthorizePage, reqData)
        .then(res => {
          let data = res.data.data.list;
          data.map(v => {
            if (v.picStatus == "0") {
              v.picStatusText = "成功";
            } else {
              v.picStatusText = "失败";
            }
          });
          this.total2 = res.data.data.total;
          this.tableData2 = data;
        })
        .catch(errorHandler("获取数据失败"));
    },
    handleSizeChange(val) {
      this.requestData.pageSize = val;
      this.getPage();
    },
    handleCurrentChange(val) {
      this.requestData.pageNum = val;
      this.getPage();
    },
    handleSizeChange2(val) {
      this.pageSize2 = val;
      this.getPersonPage();
    },
    handleCurrentChange2(val) {
      this.pageNum2 = val;
      this.getPersonPage();
    },
    search(v) {
      // this.requestData.pageNum = 1;
      this.requestData[v.key] = v.value;
      // this.getPage();
    },

    upData2: function() {
      let that = this;
      const oFReader = new FileReader();
      const file = document.getElementById("uploadGuidedGraph").files[0];
      if (file.size > 1024 * 1024) {
        nError("上传图片不能大于1M");
        return false;
      }
      oFReader.readAsDataURL(file);
      oFReader.onloadend = function(oFRevent) {
        const src = oFRevent.target.result;
        that.pictureBase64 = src;
        that.uploadPicture();
      };
    },
    upImg2: function() {
      document.getElementById("#uploadBackgroundImg");
      $("#uploadGuidedGraph")
        .click() // 隐藏了input:file样式后，点击头像就可以本地上传
        .on("change", function() {
          // const objUrl = getObjectURL(this.files[0])
          // if (objUrl) {
          //   $('#pic2').attr('src', objUrl)
          // }
        });
    },
    // 上传图片
    uploadPicture() {
      this.imgList.map(v => {
        if (v.indexOf("hangzhou.aliyuncs") == -1) {
          this.$axios
            .post(api.uploadImg, {
              picData: v
            })
            .then(res => {
              if (res.data.retCode === 1) {
                this.pictureList.push(res.data.data);
                if (this.pictureList.length == this.imgList.length) {
                  this.searchPhoto();
                  this.pictureList = [];
                }
              }
            });
        } else {
          this.pictureList.push(v);
          if (this.pictureList.length == this.imgList.length) {
            this.searchPhoto();
            this.pictureList = [];
          }
        }
      });
    },
    fileClick() {
      document.getElementById("upload_file").click();
    },
    fileChange(el) {
      if (!el.target.files[0].size) return;
      this.fileList(el.target.files);
      el.target.value = "";
    },
    fileList(files) {
      for (let i = 0; i < files.length; i++) {
        this.fileAdd(files[i]);
      }
    },
    fileAdd(file) {
      // console.log(file);
      this.size = this.size + file.size; //总大小
      let reader = new FileReader();
      reader.vue = this;
      reader.readAsDataURL(file);
      reader.onload = function() {
        file.src = this.result;
        if (this.vue.imgList.length >= 5) {
          nError("最多选择五张图片进行检索");
        } else {
          this.vue.imgList.push(file.src);
        }
        // this.vue.imgList.push({
        //   file
        // });
      };
    },
    fileDel(index) {
      // this.size = this.size - this.imgList[index].file.size; //总大小
      this.imgList.splice(index, 1);
    },
    bytesToSize(bytes) {
      if (bytes === 0) return "0 B";
      let k = 1000, // or 1024
        sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
        i = Math.floor(Math.log(bytes) / Math.log(k));
      return (bytes / Math.pow(k, i)).toPrecision(3) + " " + sizes[i];
    },
    dragenter(el) {
      el.stopPropagation();
      el.preventDefault();
    },
    dragover(el) {
      el.stopPropagation();
      el.preventDefault();
    },
    drop(el) {
      el.stopPropagation();
      el.preventDefault();
      this.fileList(el.dataTransfer.files);
    },
    batchDownloadNotice() {
      // console.log(this.imgList);
      this.imgList = [];
    },
    toAddPage() {
      this.showTip = true;
      this.faceDatabaseList = [];
      this.indexList = [];
    },

    // searchCallback: function (token){
    //   this.$axios.get(api.searchCallbackByPicture+'/'+token).then(res=>{
    //     console.log(res)
    //   })
    // },

    searchPhoto() {
      let that = this;
      // this.uploadPicture();
      this.requestData.similarity = this.similarity;
      if (this.requestData.similarity && this.requestData.similarity<60) {
        nError("输入的相似度必须大于等于60%")
        return;
      }
      if (!this.requestData.similarity) {
        this.requestData.similarity = 60;
      }
      if(!this.requestData.deviceCode){
        nError("请选择监测点");
        return false;
      }
      if(!this.requestData.channelId){
        nError("请选择摄像机通道");
        return false;
      }
      if (this.timevalue) {
        this.requestData.startTime = this.timevalue[0];
        this.requestData.endTime = this.timevalue[1];
      } else {
        this.requestData.startTime = "";
        this.requestData.endTime = "";
      }
      this.requestData.pics = this.pictureList;
      // this.requestData.deviceCode = this.deviceCode;
      this.$axios
        .post(api.SearchByPicture, this.requestData)
        .then(res => {
          this.total = res.data.data.total;
          let token =res.data.data.findToken
          this.loading=true
          if(token=='-1'){
            this.tableData = res.data.data.candidateInfos;
          }else {
            setTimeout(function () {
              that.$axios.get(api.searchCallbackByPicture+'/'+token).then(res=>{
                that.tableData = res.data.data
                // that.total=res.data.data.length
              }).catch(errorHandler('搜索图片失败'))
              .finally(()=>{that.loading=false})
            },5000)
          }
        })
        .catch(errorHandler("搜索失败"));
    },

    personChoose(data, index) {
      // console.log(data);
      if (this.faceDatabaseList.includes(data.picUrl)) {
        for (let i = 0; i < this.faceDatabaseList.length; i++) {
          if (this.faceDatabaseList[i] == data.picUrl) {
            this.faceDatabaseList.splice(i, 1);
            this.indexList.splice(i, 1);
          }
        }
      } else {
        this.indexList.push(data.picUrl);
        this.faceDatabaseList.push(data.picUrl);
      }
      // console.log(this.faceDatabaseList);
    },
    confirm() {
      if (this.imgList.length > 5) {
        nError("最多选择五张图片进行检索");
      } else {
        this.imgList = this.imgList.concat(this.faceDatabaseList);
        if (this.imgList.length > 5) {
          this.imgList = this.imgList.slice(0, 5);
          nError("最多选择五张图片进行检索");
        }
        this.showTip = false;
      }
    },
  },
  watch: {
    timevalue() {
      this.getPage();
    }
  }
};

</script>



<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
</style>

<style scoped lang="less">
.background {
  display: flex;
  flex-wrap: wrap;
}
.box {
  width: 286px;
  height: 230px;
  background-color: #eff2ff;
  border: 1px solid #e9e9eb;
  border-radius: 8px;
  margin: 10px 20px;
}
.information {
  height: 85%;
  background-color: #fff;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.photo {
  width: 110px;
  height: 141px;
  user-select: none;
  margin-left: 20px;
}
.photo2 {
  width: 110px;
  height: 141px;
  border-radius: 8px;
}
.person {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  user-select: none;
}
.gender {
  margin: 20px 0;
}
.position {
  height: 15%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 5px;
}

.search-photo {
  background-color: #fff;
  border-bottom: 25px solid #eff1f7;
  height: 240px;
}

.selected-photo {
  width: 110px;
  height: 141px;
  background-color: #ff0000;
}
.chosed {
  border: 1px solid #3362f6;
  background-color: yellow !important;
}

.active {
  border: 1px solid #3362f6;
  box-shadow: 0px 0px 16px rgba(51, 98, 246, 0.3);
}

.address {
  width: 128px;
  text-align: left;
}

/deep/ .el-progress__text {
  font-size: 20px !important;
}
</style>

<style scoped lang="less">
.image-collections {
  /deep/ .el-loading-mask {
    position: fixed;
  }
}

.upload_warp_img_div_del {
  position: absolute;
  top: 0px;
  width: 16px;
  right: 4px;
  user-select: none;
}

.upload_warp_img_div_top {
  position: absolute;
  top: 0;
  width: 100%;
  height: 30px;
  background-color: rgba(0, 0, 0, 0.4);
  line-height: 30px;
  text-align: left;
  color: #fff;
  font-size: 12px;
  text-indent: 4px;
}

.upload_warp_img_div_text {
  white-space: nowrap;
  width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.upload_warp_img_div img {
  height: 150px;
  width: 120px;
  vertical-align: middle;
}

.upload_warp_img_div {
  position: relative;
  height: 150px;
  width: 120px;
  border: 1px solid #ccc;
  margin: 0px 5px 5px 0px;
  float: left;
  line-height: 100px;
  display: table-cell;
  text-align: center;
  background-color: #eee;
  cursor: pointer;
}

.upload_warp_img {
  // border-top: 1px solid #d2d2d2;
  padding: 5px 0 0 5px;
  overflow: hidden;
}

.upload_warp_text {
  text-align: left;
  margin-bottom: 5px;
  padding-top: 5px;
  text-indent: 14px;
  border-top: 1px solid #ccc;
  font-size: 14px;
}

.upload_warp_right {
  float: left;
  width: 57%;
  margin-left: 2%;
  height: 100%;
  border: 1px dashed #999;
  border-radius: 4px;
  line-height: 130px;
  color: #999;
}

.upload_warp_left button {
  // margin: 8px 5px 0px 5px;
  cursor: pointer;
  margin-left: 10px;
}

.upload_warp_left {
  float: left;
  // display: flex;
}

.upload_warp {
  margin: 5px;
  user-select: none;
}

.upload {
  // border-left: 1px solid #ccc;
  // border-right: 1px solid #ccc;
  // background-color: #fff;
  // width: 770px;
  // box-shadow: 0px 1px 0px #ccc;
  // border-radius: 4px;
}

.hello {
  width: 770px;
  text-align: center;
}

.btn {
  height: 32px;
  width: 90px;
  background-color: #1362ff;
  border: none;
  color: #fff;
  border-radius: 4px;
}

.upload-btn {
  padding-top: 10px;
  display: flex;
}

.f-size{
  font-size:14px !important;
}

/deep/.el-range-separator{
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/FaceRecognition/ImageCollections/ImageCollections.vue